const { getAsyncJSON, postAsyncJSON } = require("./shared");
const {
    updateWorkingDialog,
    hideWorkingDialog,
    showWorkingDialog,
} = require("./dialogs");

const { AFFILIATE_IDS, LOOM_BASE_URL } = require("../../modules/sw-constants");

// API - Account
function fetchTiers(planId, successFn, errorFn) {
    var url = "/api/account/plans/" + planId + "/tiers";
    var data = {};
    getObjects(url, data, "Fetching tiers", successFn, errorFn);
}
// API - Account
function fetchPaymentIntent(items, successFn, errorFn) {
    const url = "/stripe/api/create-payment-intent";
    postAsyncJSON(url, items, "", successFn, errorFn);
}
// export function createCustomerAndSetupIntent(items, successFn, errorFn) {
//     const url = "/stripe/api/createSetupIntentForCustomer";
//     postAsyncJSON(url, items, "", successFn, errorFn);
// }
function fetchSetupIntent(items, successFn, errorFn) {
    const url = "/stripe/api/create-setup-intent";
    postAsyncJSON(url, items, "", successFn, errorFn);
}
function retrievePaymentIntent(clientSecret, successFn, errorFn) {
    const url = "/stripe/api/retrievePaymentIntent/" + clientSecret;
    const data = {};
    getAsyncJSON(url, data, "", successFn, errorFn);
}

// API
function patchAthlete(ath, params, successFn, errorFn) {
    var url = "/api/athletes/" + ath.id;

    // id is required
    var data = {
        athId: ath.id,
    };

    if (params.hasOwnProperty("emailOptIn")) {
        data.emailOptIn = params.emailOptIn === true;
    }

    if (params.hasOwnProperty("gender")) {
        data.gender = params.gender;
    }

    // call the patch
    patchAsyncJSON(url, data, "Updating athlete", function (result) {
        if (result.success) {
            successFn(result.ath);
        } else {
            if (isDefined(errorFn)) {
                errorFn(result.message);
            } else {
                showFlashError(result.message || "An error has occurred.");
            }
        }
    });
}

function patchAthleteTrack(athId, params, successFn, errorFn) {
    // call the patch
    patchAsyncJSON(
        "/api/athletes/" + athId + "/tracks",
        params,
        "Updating athlete track",
        function (result) {
            if (result.success) {
                successFn(result.ath);
            } else {
                if (isDefined(errorFn)) {
                    errorFn(result.message);
                } else {
                    showFlashError(result.message || "An error has occurred.");
                }
            }
        }
    );
}

function fetchBarbellLifts(params, successFn, errorFn) {
    var data = params || {};
    getObjects(
        "/api/barbelllifts",
        data,
        "Fetching barbell lifts",
        successFn,
        errorFn
    );
}

function fetchBarbellLift(params, successFn, errorFn) {
    var bblId = params.bblId;
    getObjects(
        "/api/barbelllifts/" + bblId,
        {},
        "Fetching barbell lift",
        successFn,
        errorFn
    );
}

function fetchAffiliateBarbellLifts(params, successFn, errorFn) {
    var data = params || {};
    getObjects(
        "/api/affiliates/barbelllifts",
        data,
        "Fetching gym barbell lifts",
        successFn,
        errorFn
    );
}

function fetchEndurances(params, successFn, errorFn) {
    var data = params || {};
    getObjects(
        "/api/endurance",
        data,
        "Fetching endurances",
        successFn,
        errorFn
    );
}

function fetchPowerMovements(params, successFn, errorFn) {
    var data = params || {};
    getObjects(
        "/api/power",
        data,
        "Fetching power movements",
        successFn,
        errorFn
    );
}

function fetchFunctionalMovements(params, successFn, errorFn) {
    var data = params || {};
    getObjects(
        "/api/functional",
        data,
        "Fetching functional movements",
        successFn,
        errorFn
    );
}

function fetchLibraryWorkout(params, successFn, errorFn) {
    var lwId = params.lwId;
    getObjects(
        "/api/library/workouts/" + lwId,
        {},
        "Fetching library workout",
        successFn,
        errorFn
    );
}
/**
 * @description Fetches a specific workout from the API.
 * @param {string} swId - The ID of the scheduled workout to fetch.
 * @param {Object} params - The parameters for the API request.
 * @param {Function} successFn - The callback function to execute on success.
 * @param {Function} [errorFn=errorHandler] - The callback function to execute on error.
 */
function fetchWorkout(swId, params, successFn, errorFn) {
    getObjects(
        `/api/workouts/${swId}`,
        params,
        "Fetching workouts",
        successFn,
        errorFn
    );
}

/**
 * @description Fetches workouts from the API.
 * @param {Object} params - The parameters for the API request.
 * @param {Function} successFn - The callback function to execute on success.
 * @param {Function} [errorFn=errorHandler] - The callback function to execute on error.
 */
function fetchWorkouts(params, successFn, errorFn) {
    getObjects(
        "/api/workouts",
        params,
        "Fetching workouts",
        successFn,
        errorFn
    );
}

function fetchAthlete(athId, params, successFn, errorFn) {
    getObjects(
        "/api/athletes/" + athId,
        params,
        "Fetching athlete",
        successFn,
        errorFn
    );
}

function fetchAthleteTracks(athId, params, successFn, errorFn) {
    getObjects(
        "/api/athletes/" + athId + "/tracks",
        params,
        "Fetching athlete tracks",
        successFn,
        errorFn
    );
}

async function fetchAthletesWithAccess(params, successFn, errorFn) {
    await fetchAthletesWithAccessAsync(
        params,
        null,
        null,
        showWorkingDialog("Retrieving athletes"),
        successFn
    );

    // getObjects(
    //     "/api/affiliates/athletes-with-access",
    //     params,
    //     "Fetching athletes",
    //     successFn,
    //     errorFn
    // );
}
// ATHLETES
const fetchAthletesWithAccessAsync = async (
    params = {},
    objsArray,
    skip,
    dialog,
    successFn,
    errorFn
) => {
    const LIMIT = 1000;
    const err = errorFn || errorHandler;
    objsArray = objsArray || [];
    skip = skip || 0;

    params = params || {}; // params may include other attributes like coachesOnly or createdTrailingDays
    params.skip = skip;
    params.limit = LIMIT;
    objsArray = objsArray || [];

    const URL = "/api/affiliates/athletes-with-access";
    const updateWorkingDialogMessage = params.RESULTS_TO_FETCH
        ? `Retrieving athletes fetching top (${objsArray.length})`
        : `Retrieving athletes (${objsArray.length} found)`;
    const getAsyncMessage = "Loading athletes";

    const onGetAsyncSuccess = async (result) => {
        const accesses = objsArray.concat(result.data || []);
        const updateWorkingMessage = params.RESULTS_TO_FETCH
            ? `Retrieving athletes fetching top (${accesses.length})`
            : `Retrieving athletes (${accesses.length} found)`;

        if (result.success) {
            successFn(result.data);
        } else {
            hideWorkingDialog(dialog);
            err(result.message || "An error has occurred.");
        }
        const allowQuery = result.data.length === LIMIT;

        if (allowQuery) {
            await fetchAthletesWithAccessAsync(
                // Recursively call until limit, Probably what causes error.
                params,
                accesses,
                skip + LIMIT,
                dialog,
                successFn
            );
        } else {
            updateWorkingDialog(dialog, updateWorkingMessage);
            await successFn(accesses);
            hideWorkingDialog(dialog);
        }
    };

    updateWorkingDialog(dialog, updateWorkingDialogMessage);
    return await getAsyncJSON(URL, params, getAsyncMessage, onGetAsyncSuccess);
};

function fetchAffiliateAthleteIdentities(identities, data, successFn) {
    // TODO: loop through 'each'
    const identity = identities[0];

    let dialog = showWorkingDialog("Fetching Athlete Identities");

    var url =
        "/api/affiliates/integration/" +
        identity.provider +
        "/athlete-identities";

    getAsyncJSON(url, data, "Loading athlete identities", function (result) {
        if (result.success) {
            hideWorkingDialog(dialog);
            successFn(result.data);
        } else {
            hideWorkingDialog(dialog);
            showFlash(
                "warning",
                "Error fetching athlete identities.",
                result.message
            );
        }
    });
}

function fetchResults(athletes, params, successFn, errorFn) {
    // "athletes" parameter must be one of:
    // - an athlete ID (string)
    // - an array of athlete IDs (Array)
    // - the string "all" --will fetch all athletes with access to the current affiliate server-side (string)

    // in all cases, the number of athletes' results being requested must be less than 1000 athletes.

    if (typeof athletes === "string") {
        if (athletes === "all") {
            // will fetch all athletes-with-access server-side.
            params.athleteIDs = "all";
        } else {
            // must be a single athlete ID
            params.athleteIDs = [athletes];
        }

        _fetchResults(params, successFn, errorFn);
    } else if (Array.isArray(athletes)) {
        // given a specific array of Athlete IDs, fetch the results in batches.
        _fetchResultsForAthleteIDsBatch(
            _.chunk(athletes, 50),
            null,
            params,
            successFn,
            errorFn
        );
    } else if (errorFn) {
        errorFn("Invalid athletes requested.");
    }
}

// video
function fetchVideoInfo(videoInfo, successFn) {
    // fetch video meta data

    let url = "",
        data = {};

    switch (videoInfo.provider) {
        case "youtube":
            url = "/api/affiliates/youtubevideo";
            data.videoIds = [videoInfo.id];
            break;
        case "romwod":
            url = "/api/affiliates/romwodvideo";
            data.videoId = videoInfo.id;
            break;
        case "vimeo-pro":
            url = "/api/affiliates/vimeovideo";
            data.videoId = videoInfo.id;
            break;
        case "loom":
            url = "/api/affiliates/loomvideo";
            data.videoId = videoInfo.id;
            break;
    }
    if (url.length === 0) return;

    getAsyncJSON(url, data, "", function (result) {
        if (result.success) {
            successFn(result, videoInfo.provider);
        } else {
            showFlashError(
                result.message || "Unable to find video info, try again."
            );
        }
    });
}

function renderMediaPlayer(
    mediaProvider,
    videoMetadata,
    videoContainerElement
) {
    if (!(mediaProvider || videoMetadata || videoContainerElement)) return "";
    switch (mediaProvider) {
        case "youtube":
            renderYoutubePlayer(videoContainerElement, videoMetadata.id);
            break;
        case "romwod":
        case "vimeo-pro":
            const srcUrl = videoMetadata.containerUrls.mp4;
            const thumbUrl = videoMetadata.thumbnails.default.url;

            renderVideoPlayer(videoContainerElement, srcUrl, thumbUrl);
            break;
        case "loom":
            renderLoomPlayer(videoContainerElement, videoMetadata.id);
            break;
    }
}

function renderVideoPlayer(videoContainerElement, srcUrl, thumbUrl) {
    if (!(videoContainerElement || srcUrl || thumbUrl)) return "";

    const videoPlayerEl =
        '<video poster="' +
        thumbUrl +
        '"  controls>' +
        '<source src="' +
        srcUrl +
        '" type="video/mp4">' +
        "</video>";

    videoContainerElement.empty();
    videoContainerElement.append(videoPlayerEl);
}

function renderYoutubePlayer(youtubeContainerEl, mediaId) {
    if (!(youtubeContainerEl || mediaId)) return "";

    const youtubePlayerEl = $('<div id="youtube-player-' + mediaId + '">');

    youtubeContainerEl.empty();
    youtubeContainerEl.append(youtubePlayerEl);

    new YT.Player(youtubePlayerEl.get(0), {
        videoId: mediaId,
        playerVars: {
            autohide: 1,
            autoplay: 0,
            controls: 1,
            rel: 1,
            showinfo: 0,
            iv_load_policy: 0,
            modestbranding: 1,
        },
    });
}

function renderLoomPlayer(loomContainerEl, mediaId) {
    if (!(loomContainerEl && mediaId)) return "";

    // loom videos play only via iframe (no direct mp4), matching the embed-responsive wrapper
    const loomIframeEl = $(
        '<iframe src="' +
            LOOM_BASE_URL +
            "embed/" +
            mediaId +
            '" frameborder="0" webkitallowfullscreen mozallowfullscreen ' +
            'allowfullscreen class="embed-responsive-item"></iframe>'
    );

    loomContainerEl.empty();
    loomContainerEl.append(loomIframeEl);
}

function parseVideoUrl(url) {
    // return obj with id and provider
    const response = {
        id: null,
        provider: "",
    };

    const providers = ["youtube", "romwod", "vimeo-pro", "loom"];
    let providerRegex = "";
    let matches = [];

    // attempt to match URL to one of our supported providers
    _.each(providers, function (provider) {
        // if we haven't found an id yet, keep trying other providers
        if (!response.id) {
            // set provider name
            response.provider = provider;

            // use different regex depending on provider
            switch (provider) {
                case "youtube":
                    // supports youtube urls in the following formats:
                    // https://www.youtube.com/watch?v=tMoVOgyv5qU
                    // http://youtu.be/tMoVOgyv5qU
                    providerRegex =
                        /(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/;
                    break;
                case "romwod":
                    // supports romwod urls in the following formats:
                    // romwod/DwDmxUQM3N4
                    providerRegex = /(?:romwod\/)([^\s\/]+)/;
                    break;
                case "vimeo-pro":
                    // supports vimeo urls in the following formats:
                    // https://vimeo.com/408633543
                    providerRegex =
                        /(?:https?:\/{2})?(?:w{3}\.)?vimeo?\.(?:com)\/([^\s\/]+)/;
                    break;
                case "loom":
                    // supports loom urls in the following formats:
                    // <LOOM_BASE_URL>share/473fad25ebd24b5ea8091503253dfecf
                    // <LOOM_BASE_URL>embed/473fad25ebd24b5ea8091503253dfecf
                    providerRegex =
                        /(?:https?:\/{2})?(?:w{3}\.)?loom\.com\/(?:share|embed)\/([A-Za-z0-9]+)/;
                    break;
            }

            // find regex matches
            matches = url.match(providerRegex);

            // if we have a match, save it
            response.id = matches && matches.length > 0 ? matches[1] : null;
        }
    });

    return response;
}

// private results functions
function _fetchResultsForAthleteIDsBatch(
    arrayOfArraysOfAthleteIDs,
    wrs,
    params,
    successFn,
    errorFn
) {
    // get the WRs for the first arrayOfAthleteIDs in the arrayOfArraysOfAthleteIDs
    // recurse as necessary until all athleteIDs have been sent in to "fetchResults"

    // arrayOfArraysOfAthleteIDs = [["ath1", "ath2", ...], ["ath51", "ath52", ...], ...]

    // keep dialog updated if one is initiated.
    // (optional because some pages have other data to explore while results are fetched)
    const dialog = $(".bootbox");
    const hasDialog = dialog.length > 0 && dialog.is(":visible");

    if (!isDefined(wrs)) wrs = [];

    if (arrayOfArraysOfAthleteIDs.length) {
        // fetch a batch of results for the first arrayOfAthleteIDs
        params.athleteIDs = _.first(arrayOfArraysOfAthleteIDs);
        _fetchResults(
            params,
            function (wrsBatch) {
                // update dialog if present
                if (hasDialog) {
                    params.resultCount =
                        (params.resultCount ? params.resultCount : 0) +
                        wrsBatch.length;
                    params.athleteCount =
                        (params.athleteCount ? params.athleteCount : 0) +
                        params.athleteIDs.length;
                    updateWorkingDialog(
                        dialog,
                        "Fetching results (" +
                            params.resultCount +
                            " found out of " +
                            params.athleteCount +
                            " athletes searched)"
                    );
                }

                // remove the first arrayOfArrays and recurse...
                _fetchResultsForAthleteIDsBatch(
                    _.rest(arrayOfArraysOfAthleteIDs),
                    wrs.concat(wrsBatch),
                    params,
                    successFn,
                    errorFn
                );
            },
            errorFn
        );
    } else {
        // hide dialog if present
        if (hasDialog) {
            hideWorkingDialog(dialog);
        }
        // all done, no more athleteIDs to consider...
        successFn(wrs);
    }
}

function _fetchResults(params, successFn, errorFn) {
    getObjects(
        "/api/results",
        params,
        "Fetching workout results",
        successFn,
        errorFn
    );
}

function fetchWorkoutResults(swId, params, successFn, errorFn) {
    getObjects(
        "/api/workouts/" + swId + "/results",
        params,
        "Fetching workout results",
        successFn,
        errorFn
    );
}

function fetchBarbellPRs(athId, params, successFn, errorFn) {
    getObjects(
        "/api/results/athletes/" + athId + "/barbellprs",
        params,
        "Fetching barbell results",
        successFn,
        errorFn
    );
}

function fetchWhiteboards(params, successFn, errorFn) {
    getObjects(
        "/api/social/whiteboards",
        params,
        "Fetching whiteboards",
        successFn,
        errorFn
    );
}

function fetchSubscriptions(publisherId, params, successFn, errorFn) {
    getObjects(
        "/api/marketplace/publishers/" + publisherId + "/subscriptions",
        params,
        "Fetching subscriptions",
        successFn,
        errorFn
    );
}

function fetchTracksHistory(trackId, params, successFn, errorFn) {
    getObjects(
        "/api/athletes/tracks/" + trackId + "/allTracksHistory",
        params,
        "Fetching tracks history",
        successFn,
        errorFn
    );
}
function fetchTracks(params, successFn, errorFn) {
    getObjects(
        "/api/affiliates/tracks",
        params,
        "Fetching tracks",
        successFn,
        errorFn
    );
}

// API geo
function fetchTimeZone(params, successFn, errorFn) {
    var data = params || {};
    getObjects(
        "/api/system/timezone",
        data,
        "Fetching timezone",
        successFn,
        errorFn
    );
}

function fetchGeoPoint(params, successFn, errorFn) {
    var data = params || {};
    getObjects(
        "/api/system/geopoint",
        data,
        "Fetching geopoint",
        successFn,
        errorFn
    );
}

// fetch support
function getObjects(
    url,
    params,
    description,
    successFn,
    errorFn = errorHandler
) {
    if (typeof successFn !== "function") return errorFn("Missing parameter.");

    const dialog = $(".bootbox");
    const hasDialog = dialog.length > 0 && dialog.is(":visible");

    getAsyncJSON(url, params, description, (result) => {
        if (result.success) {
            successFn(result.data);
        } else {
            // Closing the dialog here in case of an error.
            // Most of the functions do not pass the dialog parameter to this function.
            if (hasDialog) hideWorkingDialog(dialog);
            errorFn(result.message || "An error has occurred.");
        }
    });
}

function errorHandler(message) {
    showFlashError(message || "An error has occurred.");
}

// patch support
function patchData(data, key, type, aModel, newVal) {
    // add the key and newVal to the data object
    // iff the newVal is different from the model's current value

    const oldVal = aModel[key];

    switch (type) {
        case "str":
            newVal = typeof newVal !== "undefined" ? newVal.trim() : null;
            break;
        case "int":
            if (typeof newVal === "string" && newVal.trim().length > 0) {
                newVal = parseInt(newVal, 10);
            } else {
                newVal = 0;
            }
            break;
        case "bool":
            break;
        case "array":
            break;
    }

    // different "equivalent" testing for arrays and others...
    if (type === "array") {
        // makes assumption that order does not matter
        if (!arraysHaveSameItems(newVal, aModel[key])) {
            aModel[key] = newVal;
            data[key] = newVal;
        }
    } else if (type === "obj") {
        if (!_.isEqual(newVal, oldVal)) {
            aModel[key] = newVal;
            data[key] = newVal;
        }
    } else {
        if (newVal !== oldVal) {
            aModel[key] = newVal;
            data[key] = newVal;
        }
    }
}

// Barbell (should make 'models' server and client side!
function barbellWorkoutTitleWithSetSpecs(bbl, bblSetSpecs) {
    if (!bbl || !bblSetSpecs || bblSetSpecs.length === 0) {
        return bbl && bbl.name ? bbl.name : "";
    }

    var setCount = bblSetSpecs.length;

    // constant or variable
    var isConstantReps = true;
    var set1Spec = bblSetSpecs[0];
    var set1RepCount = parseInt(set1Spec.repsrx);

    var reps = [];
    reps.push(set1RepCount);
    for (var set = 1; set < setCount; set++) {
        var repCount = parseInt(bblSetSpecs[set].repsrx);
        reps.push(repCount);
        if (repCount !== set1RepCount) {
            isConstantReps = false;
        }
    }

    var nameStr = bbl.name + " ";
    if (isConstantReps) {
        nameStr = nameStr + setCount + "x" + set1RepCount;
    } else {
        var suffix = _.reduce(reps, function (memo, rep) {
            return memo + "-" + rep;
        });
        nameStr = nameStr + suffix;
    }

    return nameStr;
}

function barbellSetSpecsHaveSpecifiedPercent(bblSetSpecs) {
    if (!bblSetSpecs || bblSetSpecs.length === 0) {
        return false;
    }

    const notSpecified = _SugarWOD.constants.barbell_spec_percent_not_specified;
    return _.some(bblSetSpecs, function (spec) {
        const percent = parseInt(spec.percent, 10);
        return Number.isInteger(percent) && percent !== notSpecified;
    });
}

function barbellUncheckedAutoText(bbl, specs) {
    if (!bbl || !specs || specs.length === 0) {
        return "";
    }
    var withoutPercent = [];
    for (var i = 0; i < specs.length; i++) {
        withoutPercent.push({
            repsrx: specs[i].repsrx,
            percent: 110,
        });
    }
    return barbellWorkoutDescriptionWithSetSpecs(bbl, withoutPercent).trim();
}

// When % is off, the description is the enumerated set list without %
// ("Deadlift for load: #1: 5 reps …"). If the current description still starts
// with the previous auto text, replace that block and keep coach notes below.
function barbellDescriptionWithUpdatedTitle(
    currentText,
    previousTitle,
    newTitle
) {
    var text = currentText == null ? "" : String(currentText);
    if (normalizeBblDescription(text) === "") {
        return newTitle;
    }
    if (!previousTitle) {
        return text;
    }
    var custom = barbellCustomNotesFromDescription(text, previousTitle);
    if (
        custom &&
        custom === normalizeBblDescription(text) &&
        normalizeBblDescription(text) !== normalizeBblDescription(previousTitle)
    ) {
        return text;
    }
    return barbellUncheckedDescription(newTitle, custom);
}

function normalizeBblDescription(text) {
    return (text || "")
        .replace(/\r\n/g, "\n")
        .split("\n")
        .map(function (line) {
            return line.replace(/^[ \t]+/, "").replace(/[ \t]+$/, "");
        })
        .join("\n")
        .replace(/^\n+/, "")
        .replace(/\n+$/, "")
        .trim();
}

function barbellCustomNotesFromDescription(text, autoTitle) {
    var raw = normalizeBblDescription(text);
    var auto = normalizeBblDescription(autoTitle);
    if (!raw) {
        return "";
    }
    if (!auto || raw === auto) {
        return "";
    }
    if (raw.indexOf(auto) === 0) {
        return raw.slice(auto.length).replace(/^\s+/, "");
    }
    return raw;
}

function barbellUncheckedDescription(title, customNotes) {
    var notes = (customNotes || "").trim();
    if (!notes) {
        return title;
    }
    if (notes === title || notes.indexOf(title + "\n") === 0) {
        return notes;
    }
    return title + "\n\n" + notes;
}

function barbellWorkoutDescriptionWithSetSpecs(bbl, bblSetSpecs) {
    var str = bbl.name + " for load:\n";

    // build a single set-spec line, optionally prefixed with a set label (e.g. "#1")
    function lineForSetSpec(setSpec, label) {
        var repCount = setSpec.repsrx;
        var line = " ";
        if (isDefined(label)) {
            line += label + ": ";
        }
        line += repCount + " rep";
        if (repCount > 1) {
            line += "s";
        }

        var percent = _SugarWOD.constants.barbell_spec_percent_not_specified;
        if (setSpec.percent) {
            percent = setSpec.percent;
        }
        if (
            percent !== _SugarWOD.constants.barbell_spec_percent_not_specified
        ) {
            line += " @ " + percent + "%";
        }
        return line + "\n";
    }

    // one row per set for both constant and variable reps
    for (var set = 0; set < bblSetSpecs.length; set++) {
        str += lineForSetSpec(bblSetSpecs[set], "#" + (set + 1));
    }

    // NOTE: coach's additional notes are intentionally NOT appended here; they are
    // stored separately in the `additionalNotes` field on the scheduled workout.

    return str;
}

function barbellPRNamesFromSetSpecs(bbl, bblSetSpecs) {
    var bblPRsRepCounts = [1, 2, 3, 4, 5];

    var allReps = _.map(bblSetSpecs, function (bblSetSpec) {
        return parseInt(bblSetSpec.repsrx, 10) || -1;
    });

    var allRepsUnique = _.sortBy(_.uniq(allReps));

    var prNames = "";
    _.each(allRepsUnique, function (repCount) {
        if (bblPRsRepCounts.indexOf(repCount) > -1) {
            if (prNames.length > 0) prNames += ", ";
            prNames += repCount + "RM";
        }
    });

    return prNames.length > 0 ? bbl.name + " " + prNames : "";
}

function enduranceWorkoutTitleWithSetSpecs(monoName, monoSetSpecs) {
    let setString = "";
    let spacerStr = "";

    if (monoSetSpecs.sets > 1) {
        setString += monoSetSpecs.sets + " x ";
    }

    let metricValue = monoSetSpecs.distValue;
    var distString;
    if (monoSetSpecs.metricType === "distance") {
        if (metricValue === 1609) {
            distString = "1 mile";
        } else {
            if (metricValue < 5000) {
                distString = "" + metricValue + "m";
            } else {
                distString = "" + parseInt(metricValue / 1000) + "k";
            }
        }

        spacerStr = metricValue === 1609 ? " " : "";
    } else {
        distString = metricValue + " calories";
    }

    return monoName + " " + setString + spacerStr + distString;
}

function enduranceWorkoutDescriptionWithSetSpecs(monoName, monoSetSpecs) {
    return enduranceWorkoutTitleWithSetSpecs(monoName, monoSetSpecs);
}

// Affiliate
function patchAffiliateMeta(aff, params, successFn, errorFn) {
    var url = "/api/affiliates/meta/" + aff.id;
    var data = params;

    // call the patch
    patchAsyncJSON(url, data, "Updating affiliate meta", function (result) {
        if (result.success) {
            successFn(result.aff);
        } else {
            if (isDefined(errorFn)) {
                errorFn(result.message);
            } else {
                showFlashError(result.message || "An error has occurred.");
            }
        }
    });
}

// Email
function previewEmailTemplate(params, successFn, errorFn) {
    var url = "/api/system/email-preview/";

    // call the patch
    getAsyncJSON(url, params, "Rendering email preview", function (result) {
        if (result.success) {
            successFn(result.data);
        } else {
            if (isDefined(errorFn)) {
                errorFn(result.message);
            } else {
                showFlashError(result.message || "An error has occurred.");
            }
        }
    });
}

// Timeline
function relativeWeekDayString(theTrack, dateInt, weekOnly) {
    const DAYS_IN_THE_WEEK = 7;

    // get offset date from track
    const timelineStartDateMoment = dateIntAsMoment(
        theTrack.timelineStartsAtDateInt
    );

    // determine number of weeks since beginning of program
    const weeksSince = dateIntAsMoment(dateInt).diff(
        timelineStartDateMoment,
        "weeks"
    );

    // determine number of days since beginning of program
    let daysSince = dateIntAsMoment(dateInt).diff(
        timelineStartDateMoment,
        "days"
    );

    // offset daysSince by number of weeks
    daysSince = daysSince - DAYS_IN_THE_WEEK * weeksSince;

    // Week 1 / Day 1
    return (
        "Week " +
        (weeksSince + 1) +
        (weekOnly ? "" : " / Day " + (daysSince + 1))
    );
}

const fetchAffiliateAthleteAccesses = async (affId, params = {}, onSuccess) => {
    await fetchAffiliateAthleteAccessesAsync(
        affId,
        params,
        null,
        null,
        showWorkingDialog("Retrieving athletes"),
        onSuccess
    );
};

// AFFILIATE
const fetchAffiliateAthleteAccessesAsync = async (
    affId,
    params,
    objsArray,
    skip,
    dialog,
    successFn
) => {
    const LIMIT = 750;

    objsArray = objsArray || [];
    skip = skip || 0;

    params = params || {}; // params may include other attributes like coachesOnly or createdTrailingDays
    params.skip = skip;
    params.limit = LIMIT;

    const URL = "/api/affiliates/" + (affId || "current") + "/user-security";
    const updateWorkingDialogMessage = params.RESULTS_TO_FETCH
        ? `Retrieving athletes fetching top (${objsArray.length})`
        : `Retrieving athletes (${objsArray.length} found)`;
    const getAsyncMessage = "Loading athletes";

    const onGetAsyncSuccess = async (result) => {
        const accesses = objsArray.concat(result.data || []);
        const updateWorkingMessage = params.RESULTS_TO_FETCH
            ? `Retrieving athletes fetching top (${accesses.length})`
            : `Retrieving athletes (${accesses.length} found)`;
        const allowQuery = params.RESULTS_TO_FETCH
            ? accesses.length < params.RESULTS_TO_FETCH
            : true;

        if (result.maybeMore && allowQuery) {
            await fetchAffiliateAthleteAccessesAsync(
                // Recursively call until limit, Probably what causes error.
                affId,
                params,
                accesses,
                skip + LIMIT,
                dialog,
                successFn
            );
        } else {
            updateWorkingDialog(dialog, updateWorkingMessage);
            await successFn(accesses);
            hideWorkingDialog(dialog);
        }
    };

    updateWorkingDialog(dialog, updateWorkingDialogMessage);
    await getAsyncJSON(URL, params, getAsyncMessage, onGetAsyncSuccess); // fetch athlete accesses for gym including athlete
};

// TODO: Investigate possible errors
// export const fetchAffiliateAthleteAccessesAsync = async (
//     affId,
//     params,
//     objsArray,
//     skip,
//     dialog,
//     successFn
// ) => {
//     const LIMIT = 1000;
//     objsArray = objsArray || [];
//     skip = skip || 0;

//     params = { ...params, skip, limit: LIMIT };

//     const URL = `/api/affiliates/${affId || "current"}/user-security`;

//     const getAsyncMessage = "Loading athletes";

//     try {
//         let continueFetching = true;

//         while (continueFetching) {
//             const updateWorkingDialogMessage = params.RESULTS_TO_FETCH
//                 ? `Retrieving athletes fetching top (${objsArray.length})`
//                 : `Retrieving athletes (${objsArray.length} found)`;
//             updateWorkingDialog(dialog, updateWorkingDialogMessage);

//             await new Promise((resolve, reject) => {
//                 const onGetAsyncSuccess = async (result) => {
//                     if (result.data) {
//                         objsArray = objsArray.concat(result.data);
//                     }

//                     const updateWorkingMessage = params.RESULTS_TO_FETCH
//                         ? `Retrieving athletes fetching top (${objsArray.length})`
//                         : `Retrieving athletes (${objsArray.length} found)`;

//                     const allowQuery = params.RESULTS_TO_FETCH
//                         ? objsArray.length < params.RESULTS_TO_FETCH
//                         : true;

//                     if (result.maybeMore && allowQuery) {
//                         skip += LIMIT;
//                         params = { ...params, skip };
//                         updateWorkingDialog(dialog, updateWorkingMessage);
//                         resolve();
//                     } else {
//                         continueFetching = false;
//                         updateWorkingDialog(dialog, updateWorkingMessage);
//                         await successFn(objsArray);
//                         hideWorkingDialog(dialog);
//                         resolve();
//                     }
//                 };
//                 const errorFunction = () => {
//                     console.error("Failed fetching athlete accesses:", error);
//                     hideWorkingDialog(dialog);
//                 };

//                 try {
//                     getAsyncJSON(
//                         URL,
//                         params,
//                         getAsyncMessage,
//                         onGetAsyncSuccess,
//                         errorFunction
//                     );
//                 } catch (error) {
//                     console.error("Failed fetching athlete accesses:", error);
//                     hideWorkingDialog(dialog);
//                     reject(error); // Exit the loop on error
//                 }
//             });
//         }
//     } catch (error) {
//         console.error("Failed fetching athlete accesses:", error);
//         hideWorkingDialog(dialog);
//     }
// };

const customersWithLargeAthleteCounts = [
    AFFILIATE_IDS.MAYHEM, // 26k+ athletes in this gym
    AFFILIATE_IDS.CROSSFIT_SUGARWOD_TEST_2, // SugarWOD Test account
    AFFILIATE_IDS.SUGARWOD_DEMO_GYM,
]; // More modular so we can add more gyms as needed.

const updateDataTableSearchUIWhenNeeded = (
    searchInputParentId,
    affiliateId,
    JQueryReference,
    fetchAthletesFunction
) => {
    if (customersWithLargeAthleteCounts.includes(affiliateId)) {
        const dataTableSearchBar = JQueryReference(
            `#${searchInputParentId} label input`
        ).hide();

        dataTableSearchBar.before(
            `<input type="text" id="${searchInputParentId}--largeAccount__searchBar" class="largeAccount__searchBar" placeholder="Search Athletes...">
            <button id="${searchInputParentId}--largeAccount__searchButton" class="largeAccount__searchButton"><i class="fa fa-search"></i></button>`
        );

        JQueryReference(`#${searchInputParentId}--largeAccount__searchBar`).on(
            "keyup",
            (e) => (e.key === "Enter" ? fetchAthletesFunction() : null)
        );

        JQueryReference(
            `#${searchInputParentId}--largeAccount__searchButton`
        ).on("click", () => fetchAthletesFunction());
    }
};

const safelyFetchAthletesRegardlessOfCount = async (
    otherParams,
    affiliateId,
    onSuccessFunction,
    searchBarQueryString,
    JQueryReference
) => {
    const RESULTS_TO_FETCH = 750;
    const permissionsTableLargeAccountSearchBar = JQueryReference(
        `#${searchBarQueryString}--largeAccount__searchBar`
    );
    const searchTerms = permissionsTableLargeAccountSearchBar.val() || "";
    const isLargeAthleteCount =
        customersWithLargeAthleteCounts.includes(affiliateId);
    await fetchAffiliateAthleteAccesses(
        affiliateId,
        isLargeAthleteCount
            ? { searchTerms, RESULTS_TO_FETCH, ...otherParams }
            : otherParams,
        onSuccessFunction
    );
};

function customUpdateDataTableSearchUI(
    searchInputParentId,
    JQueryReference,
    drawCallback
) {
    const dataTableSearchInput = JQueryReference(
        `#${searchInputParentId} label input`
    );

    // Hide default DataTables search input
    dataTableSearchInput.hide();

    // Add custom search bar and search button before it
    dataTableSearchInput.before(`
            <input type="text" id="${searchInputParentId}--customSearchInput" class="largeAccount__searchBar" placeholder="Search Athletes..." />
            <button id="${searchInputParentId}--customSearchButton" class="largeAccount__searchButton">
                <i class="fa fa-search"></i>
            </button>
        `);

    // Redraw table on Enter key
    JQueryReference(`#${searchInputParentId}--customSearchInput`).on(
        "keyup",
        function (e) {
            if (e.key === "Enter") {
                if (e.key === "Enter") {
                    drawCallback();
                }
            }
        }
    );

    // Redraw table on button click
    JQueryReference(`#${searchInputParentId}--customSearchButton`).on(
        "click",
        function () {
            drawCallback();
        }
    );
}

module.exports = {
    fetchTiers,
    fetchPaymentIntent,
    fetchSetupIntent,
    retrievePaymentIntent,
    patchAthlete,
    patchAthleteTrack,
    fetchBarbellLifts,
    fetchBarbellLift,
    fetchAffiliateBarbellLifts,
    fetchEndurances,
    fetchPowerMovements,
    fetchFunctionalMovements,
    fetchLibraryWorkout,
    fetchWorkout,
    fetchWorkouts,
    fetchAthlete,
    fetchAthleteTracks,
    fetchAthletesWithAccess,
    fetchAthletesWithAccessAsync,
    fetchAffiliateAthleteIdentities,
    fetchResults,
    fetchVideoInfo,
    renderMediaPlayer,
    renderYoutubePlayer,
    parseVideoUrl,
    fetchVideoInfo,
    renderVideoPlayer,
    parseVideoUrl,
    patchData,
    barbellWorkoutTitleWithSetSpecs,
    barbellSetSpecsHaveSpecifiedPercent,
    barbellDescriptionWithUpdatedTitle,
    barbellCustomNotesFromDescription,
    barbellUncheckedDescription,
    barbellUncheckedAutoText,
    normalizeBblDescription,
    barbellWorkoutDescriptionWithSetSpecs,
    barbellPRNamesFromSetSpecs,
    enduranceWorkoutTitleWithSetSpecs,
    enduranceWorkoutDescriptionWithSetSpecs,
    patchAffiliateMeta,
    previewEmailTemplate,
    relativeWeekDayString,
    fetchAffiliateAthleteAccesses,
    fetchAffiliateAthleteAccessesAsync,
    getObjects,
    fetchWorkoutResults,
    fetchBarbellPRs,
    fetchWhiteboards,
    fetchSubscriptions,
    fetchTracksHistory,
    fetchTracks,
    fetchTimeZone,
    fetchGeoPoint,
    errorHandler,
    customersWithLargeAthleteCounts,
    updateDataTableSearchUIWhenNeeded,
    safelyFetchAthletesRegardlessOfCount,
    customUpdateDataTableSearchUI,
};
